import { Moment } from "moment-timezone";
import { DatePeriod } from "@services/http/dto";
import { getUtcFormat, getUtcToday, getUtcTomorrow } from "@utils/moscowTime";

export function createDatePeriodParamsEx3(
  dateFrom: Moment | null,
  dateTo: Moment | null
): DatePeriod {
  return {
    date_from: dateFrom ? getUtcFormat(dateFrom) : getUtcToday(), //getServerToday(),
    date_to: dateTo ? getUtcFormat(dateTo) : getUtcTomorrow(),
  };
}

